const documentsDictionary = {
  petition: 'Proforma',
  paidPetition: 'Pedimento Pagado',
  rectifiedPetition: 'Pedimento Rectificado',
  commercialInvoice: 'Factura'
};

export default documentsDictionary;
